var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEye = function SvgIconEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9915 7.78586C13.8507 4.8692 11.0716 2.96815 7.99574 3.0004C4.9403 2.98237 2.1838 4.87085 1.04198 7.76444C1.01509 7.84003 1.0009 7.91972 1.00001 8.00014C0.999637 8.07604 1.0139 8.15128 1.04198 8.22155C2.17935 11.1207 4.93684 13.0156 7.99574 12.9999C11.0512 13.0179 13.8077 11.1294 14.9495 8.23584C14.9794 8.16112 14.9937 8.08083 14.9915 8.00014C15.0028 7.92918 15.0028 7.85682 14.9915 7.78586ZM7.99574 10.1429C6.83665 10.1429 5.89702 9.18354 5.89702 8.00014C5.89702 6.81673 6.83665 5.85739 7.99574 5.85739C9.15483 5.85739 10.0945 6.81673 10.0945 8.00014C10.0945 8.56843 9.87335 9.11344 9.47976 9.51529C9.08617 9.91713 8.55236 10.1429 7.99574 10.1429Z",
    fill: "#A9ADBB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconEye.84d373df.svg";
export { ForwardRef as ReactComponent };